import { useEffect } from "react";
import { useGetList } from "react-admin";
import { Alert, Box, Button, Card, CircularProgress, Typography, Divider } from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import BulkFlagInput from "./BulkFlagInput";

const SiteBulkForm = ({
    onError,
    availableToUserStatus,
    setAvailableToUserStatus,
    onSaveAvailableToUser,
    customerVisibilityDttm,
    setCustomerVisibilityDttm,
    onSaveCustomerVisibilityDttm,
}) => {
    const { isLoading, isError, isSuccess, error } = useGetList("portal/sites");

    useEffect(() => {
        if (isError) {
            console.error(error);
            onError();
        }
    }, [isError]);

    return (
        (isLoading && (
            <Box>
                <CircularProgress />
            </Box>
        )) ||
        (!isLoading && isSuccess && (
            <Card>
                <Typography margin={2} variant="h6">
                    Settings
                </Typography>

                <Box mb={2} ml={1} mr={2}>
                    <Alert severity="warning">
                        {"These changes will be applied to all selected sites, overwriting their current settings."}
                    </Alert>
                </Box>

                <Divider />

                <BulkFlagInput
                    type="switch"
                    label="Available to User"
                    value={availableToUserStatus}
                    onChange={setAvailableToUserStatus}
                    alertText={
                        <>
                            The selected sites will be made{" "}
                            <strong>{availableToUserStatus ? "available" : "unavailable"}</strong> to all users
                        </>
                    }
                />
                <Box mb={2} ml={2} mr={2}>
                    <Button variant="contained" startIcon={<SaveIcon />} onClick={onSaveAvailableToUser}>
                        Save
                    </Button>
                </Box>

                <Divider />

                <Typography margin={2} variant="h6">
                    Customer Visibility Date
                </Typography>
                <Box mb={2} ml={2} mr={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Customer Visibility (UTC)"
                            timezone="UTC"
                            ampm={true}
                            value={customerVisibilityDttm}
                            onChange={setCustomerVisibilityDttm}
                            slotProps={{ field: { clearable: true } }}
                        />
                    </LocalizationProvider>
                </Box>
                <Box mb={2} ml={2} mr={2}>
                    <Button variant="contained" startIcon={<SaveIcon />} onClick={onSaveCustomerVisibilityDttm}>
                        Save
                    </Button>
                </Box>
            </Card>
        ))
    );
};

export default SiteBulkForm;
